module.exports = "mutation activateCuratorPromocode($promocode: String!) { activateCuratorPromocode(promocode: $promocode) }\n"